import { render, staticRenderFns } from "./vorgang-state-badge.vue?vue&type=template&id=088e4a7c"
import script from "./vorgang-state-badge.vue?vue&type=script&lang=js"
export * from "./vorgang-state-badge.vue?vue&type=script&lang=js"
import style0 from "./vorgang-state-badge.vue?vue&type=style&index=0&id=088e4a7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports